<script>
  import { initialsFromEmail, initialsFromName } from '@client/utils/users';

  /**
   * Object containing user details.
   * @type {Object}
   * @public
   */
  export let details = {};

  /**
   * Size of the element.
   * @type {string}
   * @default 'medium'
   * @public
   */
  export let size = 'medium';

  /**
   * Color of the element.
   * @type {string}
   * @default 'var(--color-gray-200)'
   * @public
   */
  export let color = 'var(--color-gray-200)';

  /**
   * Add a border to the porthole.
   * @type {boolean}
   * @default false
   * @public
   */
  export let bordered = false;

  /**
   * Cachebust the image URL.
   * @type {boolean}
   * @default false
   * @public
   */
  export let cachebust = false;

  let photoUrl = details?.photoUrl || null;

  const renderUserInitials = () => {
    photoUrl = null;
  };

  const getInitials = () => {
    if (details.name) {
      return initialsFromName(details.name);
    }

    return initialsFromEmail(details.email);
  };

  const checkImage = (url, callback) => {
    const img = new Image();

    img.onload = () => {
      if (img.width === 1 && img.height === 1) {
        if (callback) {
          callback(url);
        } else {
          renderUserInitials();
        }
      } else {
        if (photoUrl !== url) {
          photoUrl = url;
        }
      }
    };

    img.onerror = () => renderUserInitials();
    img.src = url;

    return url;
  };

  const email = details?.email;
  const domain = email?.split('@').pop();

  if (!photoUrl?.length) {
    checkImage(`https://smart.${domain}/photo/${email}/google.jpg`, () => {
      checkImage(`https://smart.${domain}/photo/${email}/office365.jpg`, () => {
        renderUserInitials();
      });
    });
  }
</script>

<div class="porthole {size}" class:initials={!photoUrl} class:bordered>
  {#if photoUrl?.length}
    <img
      src="{photoUrl}{cachebust ? `?ts=${Date.now()}` : ''}"
      loading="lazy"
      on:error={renderUserInitials}
      alt={details.name}
      referrerpolicy="no-referrer"
    />
  {:else}
    <div class="initials" style="background-color: {color};">{getInitials()}</div>
  {/if}
</div>

<style lang="scss" src="./porthole.scss"></style>
